module.exports = __webpack_public_path__ + "media/assets/images/landing/Group 22-74b9afdfcadf9ed44bee132f5e57f12b.png";